import authAxios from '@services/authAxios';

const fetchAuditTrailExport = async ({ queries }) => {
    const { data } = await authAxios({
        method: 'GET',
        url: `/api/v1/audit-trail/download/info?${queries}`,
        responseType: 'blob',
    });

    return data;
};

export default fetchAuditTrailExport;
